import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import Spinner from "./ui/Spinner";
import FormButton from "./ui/button/FormButton";


const InvoiceButtonWithConfirmation = ({
  invoiceLoading,
  handleInvoiceClick,
  disabled = false, // default to false if not passed
  type = "button", // default to button to prevent form submission
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => setOpen(true);
  const handleCancel = () => setOpen(false);
  const handleConfirm = async () => {
    const success = await handleInvoiceClick();
    // Only close the modal on validation failure
    // On success, the page will navigate away so no need to close-
    if (success === false) {
      setOpen(false);
    }
  };


  return (
    <>
      <FormButton
        width="medium"
        label={invoiceLoading ? <Spinner width="20px" /> : "Generate Invoice"}
        onClick={handleOpenDialog}
        disabled={disabled}
        type={type}
      />

      <Dialog open={open} onClose={invoiceLoading ? undefined : handleCancel}>
        <DialogTitle>Confirm Invoice Generation</DialogTitle>
        <DialogContent>
          <Typography>
            You can only generate this invoice <strong>once</strong>, and payment is{" "}
            <strong>mandatory</strong>. Please confirm you want to proceed.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="error" disabled={invoiceLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="success"
            sx={{ minWidth: 120, display: "flex", justifyContent: "center" }}
            disabled={disabled || invoiceLoading}
          >
            {invoiceLoading ? <Spinner width="20px" /> : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};


export default InvoiceButtonWithConfirmation;
